import { Controller } from "@hotwired/stimulus";

// Toggle items visibility, based on the selected key.
// To start you need:
// 1. Define "tab-filter" controller with "selectedKey" and "optionActiveClass" values;
// 2. Define "option" targets with:
// 1. data-tab-filter-target: "option";
// 2. data-tab-filter-key: "{ Key that will show items with same key }";
// 3. data-action: "{ HTML event }->tab-filter#filterItems".
// Define "item" targets with:
// 1. data-tab-filter-target: "item";
// 2. data-tab-filter-key: "{ Item key }".

// Connects to data-controller="tab-filter"
export default class extends Controller {
  static values = {
    selectedKey: String,
    optionActiveClass: String,
  };

  static targets = ["option", "item"];

  filterItems(event) {
    this.selectedKeyValue = event.currentTarget.getAttribute(
      "data-tab-filter-key",
    );
  }

  // Callback
  selectedKeyValueChanged() {
    this.#toggleVisibilityForItems(this.selectedKeyValue);
    this.#toggleActiveClassForOptions(this.selectedKeyValue);
  }

  #toggleVisibilityForItems(value) {
    this.itemTargets.forEach((item) => {
      const filterableKey = item.getAttribute("data-tab-filter-key");
      item.classList.toggle("hidden", !filterableKey.includes(value));
    });
  }

  #toggleActiveClassForOptions(value) {
    this.optionTargets.forEach((option) => {
      const filterableKey = option.getAttribute("data-tab-filter-key");
      option.classList.toggle(
        this.optionActiveClassValue,
        filterableKey.includes(value),
      );
    });
  }
}
